import { useState } from 'react'
import { FFHelpers, FFText, RCFormProvider } from '@jlafica/rcform';
import '../assets/css/tables.css'

const PayoffCalculator = () => {
    const [payoffTableData, setPayoffTableData] = useState()
    const [formRef, setFormRef] = useState(null);

    const fieldNames = {
        balance: "balance",
        interestRate: "interestRate",
        paymentAmount: "paymentAmount",
    };
    
    const initialState = {
        [fieldNames.balance]:       { ...FFHelpers.ffInitialFieldState.input },
        [fieldNames.interestRate]:  { ...FFHelpers.ffInitialFieldState.input },
        [fieldNames.paymentAmount]: { ...FFHelpers.ffInitialFieldState.input },
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const currentFormState = formRef?.validateForm(formRef?.formState)

        if (currentFormState.isValid) {
            const payoffData = getPayoffData(
                currentFormState.fields[fieldNames.balance].value,
                currentFormState.fields[fieldNames.interestRate].value,
                currentFormState.fields[fieldNames.paymentAmount].value,
            );
            setPayoffTableData(payoffData);
        }
    }

    return (
        <div>
            <h1 className="text-center">Payoff Calculator</h1>

            <div className="standardFormWrap">
                <RCFormProvider
                    onSubmit={handleSubmit}
                    className={`formStandard ${!formRef?.formState?.isValid ? 'errors' : ''}`}
                    initialFieldState={initialState}
                    setFormRef={setFormRef}
                    id="payoff-form"
                >
                    <FormContent
                        fieldNames={fieldNames}
                        setPayoffTableData={setPayoffTableData}
                    />
                </RCFormProvider>
            </div>

            {payoffTableData && <PayoffTable data={payoffTableData} />}
        </div>
    );
}

const PayoffTable = (props) => {
    return (
        <div
            className={`standardTableWrap`}
        >
            <div className="responsive-table-wrap">
                <table
                    className={`standardTable ${props.className} spc-m-x-auto spc-m-t-2`}
                >
                    <thead>
                        <tr>
                            <th>Month</th>
                            <th>Balance</th>
                            <th>Payment</th>
                            <th>To Interest</th>
                            <th>To Principal</th>
                        </tr>
                    </thead>

                    <tbody>
                        {props.data.map((row) => {
                            return (
                                <tr key={`x-${row.month}-${row.balance}`}>
                                    <td>{row.month}</td>
                                    <td className={'currencyValue'}>
                                        ${parseFloat(row.balance).toFixed(2)}
                                    </td>
                                    <td className={'currencyValue'}>
                                        ${parseFloat(row.payment).toFixed(2)}
                                    </td>
                                    <td className={'currencyValue'}>
                                        ${parseFloat(row.interest).toFixed(2)}
                                    </td>
                                    <td className={'currencyValue'}>
                                        ${parseFloat(row.principal).toFixed(2)}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const getPayoffData = (balance, interestRate, paymentAmount) => {
    let rows = []
    let startingBalance = balance

    const getInterestPayment = (balance, apr) => {
        return (parseFloat(apr) / 12) * balance
    }

    const getPrincipalPayment = (totalPayment, interestPayment) => {
        return totalPayment - interestPayment
    }

    const getResultingBalance = (balance, principalPayment) => {
        return balance - principalPayment
    }

    for (
        let currentBalance = startingBalance, index = 0;
        currentBalance > 0 && index < 100;
        index++
    ) {
        const interestPayment = getInterestPayment(
            currentBalance,
            interestRate / 100,
        )

        let payment =
            paymentAmount > currentBalance
                ? currentBalance + interestPayment
                : paymentAmount

        const principalPayment = getPrincipalPayment(
            payment,
            interestPayment,
        )
        const resultingBalance = getResultingBalance(
            currentBalance,
            principalPayment,
        )

        const row = {
            month: index,
            balance: currentBalance,
            payment: payment,
            interest: interestPayment,
            principal: principalPayment,
        }

        rows.push(row)

        currentBalance = resultingBalance
    }

    return rows;
}

const FormContent = ({
    fieldNames,
    setPayoffTableData
}) => {
    return (
        <>
            <FFText
                fieldName={fieldNames.balance}
                type={"number"}
                label={"Balance"}
                initialValue={1000}
                formatValue={(value) => parseFloat(value)}
                wrapperModifierClass={"formField"}
                onChange={() => setPayoffTableData(null)}
                required={true}
            />

            <FFText
                fieldName={fieldNames.paymentAmount}
                type={"number"}
                label={"Monthly Payment"}
                initialValue={40}
                formatValue={(value) => parseFloat(value)}
                wrapperModifierClass={"formField"}
                onChange={() => setPayoffTableData(null)}
                required={true}
            />

            <FFText
                fieldName={fieldNames.interestRate}
                type={"number"}
                label={"Interest Rate (%)"}
                step=".1"
                min="0"
                max="100"
                initialValue={19.99}
                formatValue={(value) => parseFloat(value)}
                wrapperModifierClass={"formField"}
                onChange={() => setPayoffTableData(null)}
                required={true}
            />

            <button type="submit" className="spc-m-t-1 button button-green">
                Get Payoff
            </button>
        </>
    )
}

export default PayoffCalculator;